


// UNIVERZALNA IZRAČUNAVANJA DIMENZIJA ZA terkk modul, osnovne i pregradne profile...


export const _derivatModulProfil_extract_50_ili_70_by_vrstaprofila = (vrstaprofila) => {
  // NOVO 2023-05-12
  let tervrstaprofila_50_ili_70 = null;
  if (typeof vrstaprofila === 'string') {
    tervrstaprofila_50_ili_70 = vrstaprofila.slice(-2);
  }
  if (tervrstaprofila_50_ili_70 === '50' || tervrstaprofila_50_ili_70 === '70') {
    return tervrstaprofila_50_ili_70;
  } else {
    return null;
  }
};



export const _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje = (spoljasnja, vrstaprofila) => {
  // **** U IZRADI
  // NOVO KLADOVO 2023 MAJ
  /*
  // UnutrasnjaVisinaIzSpoljasnjeImedjuPanela treba dodati ovu funkciju
  if (dimenzijeProfila === '50') {
    unutrasnjaVisina = spoljasnjaVisina - 100;
  } else if (dimenzijeProfila === '70') {
    unutrasnjaVisina = spoljasnjaVisina - 110;
    */
  //
  const SIRINA_KRILCA_PROFILA = 20; // Krilce uvek strci 20mm iz profila. Isto vazi i za profila "50" i "70".
  let unutrasnjaIzmedjuPregradnih = null;
  let unutrasnjaIzmedjuOsnovnih = null;
  let unutrasnjaIzmedjuKrilaca = null;
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  if (tervrstaprofila_50_ili_70 === '50') {
    const SIRINA_PROFILA_50 = 50;
    unutrasnjaIzmedjuOsnovnih = spoljasnja - (2 * SIRINA_PROFILA_50); // spoljasnja - 100
    const RAZLIKA_OD_PREGRADNIH_DO_OSNOVNIH_KOD_50 = 0; // Kod profila "50" nema razlike izmedju unutrasnje izmedju osnovnih i unutrasnje izmedju pregradnih profila.
    unutrasnjaIzmedjuPregradnih = unutrasnjaIzmedjuOsnovnih; // ista // spoljasnja - 100
    unutrasnjaIzmedjuKrilaca = unutrasnjaIzmedjuOsnovnih - (2 * SIRINA_KRILCA_PROFILA); // spoljasnja - 140
    /*
    UKRATKO za profil 50:
    spoljasnja = najveca
    unutrasnjaIzmedjuPregradnih = spoljasnja - 100
    unutrasnjaIzmedjuOsnovnih = spoljasnja - 100
    unutrasnjaIzmedjuKrilaca = spoljasnja - 140
    */
  } else if (tervrstaprofila_50_ili_70 === '70') {
    const SIRINA_PROFILA_70 = 70;
    unutrasnjaIzmedjuOsnovnih = spoljasnja - (2 * SIRINA_PROFILA_70); // spoljasnja - 140
    const RAZLIKA_OD_PREGRADNIH_DO_OSNOVNIH_KOD_70 = 15;
    unutrasnjaIzmedjuPregradnih = unutrasnjaIzmedjuOsnovnih + (2 * RAZLIKA_OD_PREGRADNIH_DO_OSNOVNIH_KOD_70); // spoljasnja - 110 // kod profila "70" unutrasnja izmedju pregradnih profila je veca nego unutrasnja izmedju osnovnih profila
    unutrasnjaIzmedjuKrilaca = unutrasnjaIzmedjuOsnovnih - (2 * SIRINA_KRILCA_PROFILA); // spoljasnja - 180
    /*
    UKRATKO za profil 70:
    spoljasnja = najveca
    unutrasnjaIzmedjuPregradnih = spoljasnja - 110
    unutrasnjaIzmedjuOsnovnih = spoljasnja - 140
    unutrasnjaIzmedjuKrilaca = spoljasnja - 180
    */
  }

  return {
    spoljasnja,
    unutrasnjaIzmedjuPregradnih,
    unutrasnjaIzmedjuOsnovnih,
    unutrasnjaIzmedjuKrilaca
  };
};


// Kod širine, prosta unutrašanja je unutrašnje širina izmedju pregradnih
export const _derivatModulDimenzije_prostaUnutrasnjaSirinaIzSpoljasnje = (spoljasnjaSirina, vrstaprofila) => {
  let unutrasnjaSirina = 0;
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  if (tervrstaprofila_50_ili_70 === '50') {
    unutrasnjaSirina = spoljasnjaSirina - 100; // 100 znaci 2 * 50 profila
  } else if (tervrstaprofila_50_ili_70 === '70') {
    unutrasnjaSirina = spoljasnjaSirina - 110; // 110 znaci 2 * (70 profila - 15 razlika do pregradnih)
  }
  return unutrasnjaSirina;
};
//
export const _derivatModulDimenzije_prostaSpoljasnjaSirinaIzUnutrasnje = (unutrasnjaSirina, vrstaprofila) => {
  let spoljasnjaSirina = null;
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  if (tervrstaprofila_50_ili_70 === '50') {
    spoljasnjaSirina = Number.parseInt(unutrasnjaSirina) + 100; // 100 znaci 2 * 50 profila
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    spoljasnjaSirina = Number.parseInt(unutrasnjaSirina) + 110; // 110 znaci 2 * (70 profila - 15 razlika do pregradnih)
  }
  return spoljasnjaSirina;
};


// Kod visina, prosta unutrašanja je unutrašnje visina izmedju krilaca
export const _derivatModulDimenzije_prostaUnutrasnjaVisinaIzSpoljasnje = (spoljasnjaVisina, vrstaprofila) => {
  let unutrasnjaVisina = 0;
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  if (tervrstaprofila_50_ili_70 === '50') {
    unutrasnjaVisina = spoljasnjaVisina - 140; // 140 znaci: 2 * (50 profila + 20 krilca) = 140
  } else if (tervrstaprofila_50_ili_70 === '70') {
    unutrasnjaVisina = spoljasnjaVisina - 180; // 180 znaci: 2 * (70 profila + 20 krilca) = 180
  }
  return unutrasnjaVisina;
};
//
export const _derivatModulDimenzije_prostaSpoljasnjaVisinaIzUnutrasnje = (unutrasnjaVisina, vrstaprofila) => {
  let spoljasnjaVisina = -1;
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  if (tervrstaprofila_50_ili_70 === '50') {
    spoljasnjaVisina = Number.parseInt(unutrasnjaVisina) + 140; // 140 znaci: 2 * (50 profila + 20 krilca) = 140
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    spoljasnjaVisina = Number.parseInt(unutrasnjaVisina) + 180; // 180 znaci: 2 * (70 profila + 20 krilca) = 180
  }
  return spoljasnjaVisina;
};

